import Ajax from "@/api/ajax";
export default{
    //返利记录
    referralCommissions(params) {
        return Ajax.post("/Home/referral-commissions", params);
    },
    //下级用户列表
    referralUsers(params) {
        return Ajax.post("/Home/referral-users", params);
    },


}